app.config(['$translateProvider', function ($translateProvider) {
    $translateProvider.translations('en', {
        CONFIG: "Configuration",
        USERS: "Users",
        LECTURERS: "Lecturers",
        PROGRAMS: "Programs",
        USERS_LIST: "Users list",
        STUDENTS: "Students",
        SUBJECTS: "Subjects",
        SYLLABUS: "Syllabus",
        SELECTION: "Selection",
        STATISTICS: "Statistics",
        HOME: "Home",
        EDIT: "Edit",
        TABLE: "Schedule",
        PASSED_SUBJECTS: "Passed subjects",
        CHOICE_SUBJECTS: "Selection",
        ADMINISTRATORS: "Administrators",
        RESEND: "Resend with new filter",
        RIGHTS: "Rights",
        ROLES: "Roles",
        GRADE_TEMPLATES: "Grade templates",
        NOTIFICATION: 'NOTIFICATIONS',
        RECEIVEDNOTIFICATIONS: 'Received notifications',
        AGREEMENTS: 'Agreements',
        POLLS: 'Polls',
        QUESTIONNAIRES: 'Questionnaires',
        LEARNING_SEASONS: 'Learning Seasons',
        EV_MANAGEMENT: 'Management of evaluations',
        GROUP_POSTS: 'Group posts',
        SYLLABUS_MANAGEMENT: 'Syllabus management',
        LANGUAGE_MANAGEMENT: 'Language management',
        REMINDERS: 'Reminders',
        EVENTS: 'Events',
        STUDENT_REGISTRATION: 'Student registration',
        PROFILE_PICTURES: 'Profile pictures',
        EXAMS: 'Exams',
        AUDIENCE_TABLE_MANAGEMENT: 'Audience/table management'
    })

    $translateProvider.translations('ka', {
        CONFIG: "კონფიგურაცია",
        USERS: "მომხმარებლები",
        LECTURERS: "ლექტორები",
        PROGRAMS: "პროგრამები",
        USERS_LIST: "მომხმარებელების სია",
        STUDENTS: "სტუდენტები",
        SUBJECTS: "საგნები",
        SYLLABUS: "სილაბუსი",
        SELECTION: "არჩევითობა",
        STATISTICS: "სტატისტიკა",
        GRADES_STATISTICS: "ქულების სტატისტიკა",
        HOME: "მთავარი",
        EDIT: "რედაქტირება",
        TABLE: "ცხრილი",
        PASSED_SUBJECTS: "სასწავლო ბარათი",
        CHOICE_SUBJECTS: "საგნების არჩევა",
        ADMINISTRATORS: "ადმინისტრატორები",
        RESEND: "ახალი ფილტრით გადაგზავნა",
        RIGHTS: "უფლებები",
        ROLES: "როლები",
        GRADE_TEMPLATES: "შეფასების სქემები",
        EXAMS_LIST: "გამოცდების ცხრილი",
        NOTIFICATION: "შეტყობინებები",
        RECEIVEDNOTIFICATIONS: 'მიღებული შეტყობინებები',
        AGREEMENTS: 'შეთანხმებები',
        POLLS: 'გამოკითხვები',
        QUESTIONNAIRES: 'კითხვარები',
        SELECTION_REGISTRATION: 'უწყისები / საგნების რეგისტაცია',
        LEARNING_SEASONS: 'სასწავლო სეზონები',
        EV_MANAGEMENT: 'შეფასებების მართვა',
        GROUP_POSTS: 'ჯგუფის პოსტები',
        SYLLABUS_MANAGEMENT: 'სილაბუსების მართვა',
        LANGUAGE_MANAGEMENT: 'ენების მართვა',
        REMINDERS: 'შემხსენებლები',
        EVENTS: 'ღონისძიებები',
        STUDENT_REGISTRATION: 'სტუდენტთა რეგისტრაცია',
        PROFILE_PICTURES: 'პროფილის სურათები',
        EXAMS: 'გამოცდები',
        AUDIENCE_TABLE_MANAGEMENT : 'აუდიტორიების/ცხრილის მართვა'
    });

    $translateProvider.useSanitizeValueStrategy(null);

    var savedLang = localStorage.getItem('lang');
    $translateProvider.preferredLanguage(savedLang || 'ka');
}]);
